import { Chip, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ChannelIcon } from "../../channels/components/channel-icon";
import { momentWhen } from "../../moment-card/components/moment-card-when";
import { statusToPill } from "../../moment-card/utils";
import type { FollowUpMomentDetailsLoaderData } from "../hooks/use-follow-up-moment-details";

export const FollowUpSidebarMomentSummary: FC<{
  followUpMomentDetails: FollowUpMomentDetailsLoaderData["momentFollowUpDetails"];
}> = ({ followUpMomentDetails }) => {
  return (
    <Paper elevation={0} sx={{ p: 2 }}>
      <Stack spacing={1} direction="column">
        <Stack spacing={1} direction="row" alignItems="center">
          <ChannelIcon channel={followUpMomentDetails.channel} fontSize="medium" />
          <Typography variant="subtitle2">{followUpMomentDetails.title}</Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {followUpMomentDetails.program.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {momentWhen(followUpMomentDetails)}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {followUpMomentDetails.segment?.name && (
            <Chip
              label={followUpMomentDetails.segment.name}
              variant="outlined"
              size="small"
              sx={{ width: "fit-content" }}
            />
          )}
          {statusToPill(followUpMomentDetails.status)}
        </Stack>
      </Stack>
    </Paper>
  );
};
